import { Link } from 'react-router-dom';

import { useLogout } from '../hooks/mutations/useLogout';
import { PATHS } from '../paths';
import { useAuthState } from '../providers/AuthProvider';

import Button from './Button';

/**
 * Minimal top bar: MOPS wordmark (home link) on the left, signed-in-as email +
 * logout on the right. Dense, borders over backgrounds, single accent. The
 * wordmark is the universal way back to the tool grid from any scene.
 */
const Header = () => {
  const { user } = useAuthState();
  const { logout, isLoggingOut } = useLogout();

  return (
    <header className="border-border-primary bg-bg-primary text-fg-primary flex items-center justify-between border-b px-6 py-3">
      <Link
        to={PATHS.HOME}
        aria-label="MOPS home"
        className="focus-visible:outline-border-brand flex items-baseline gap-3 focus-visible:outline-2 focus-visible:outline-offset-4"
      >
        <span className="text-fg-brand-primary hover:text-fg-brand-primary_alt text-lg font-semibold tracking-tight transition-colors">
          MOPS
        </span>
        <span className="text-fg-tertiary text-xs uppercase tracking-widest">admin</span>
      </Link>
      <div className="flex items-center gap-4 text-xs">
        {user && <span className="text-fg-secondary font-mono">{user.email}</span>}
        <Button
          size="xs"
          color="secondary"
          isLoading={isLoggingOut}
          onClick={() => {
            void logout();
          }}
        >
          Log out
        </Button>
      </div>
    </header>
  );
};

export default Header;
